// Suggestion plugin for the chat-bot skill extension.
//
// Listens for `/` in the chat bot message input and shows a filterable menu
// of skills (name / title / description) pulled from a local array. Commits
// insert a `chatBotSkill` atom node (see chat_bot_skill.js).

import $ from 'jquery'
import tippy from 'tippy.js'
import { PluginKey } from '@tiptap/pm/state'
import { getExtensionOption, resolveTippyPortal } from '../utilities'

const pluginKey = new PluginKey('chatBotSkillSuggestion')

function cloneTemplate(selector) {
  return document
    .querySelector(selector)
    .content.firstElementChild.cloneNode(true)
}

function buildMenuContent(items) {
  const menu = cloneTemplate('.js-chat-bot-skill-menu-template')
  const ul = menu.querySelector('ul')
  const itemTemplate = cloneTemplate('.js-chat-bot-skill-menu-item-template')

  items.forEach((item) => {
    const li = itemTemplate.cloneNode(true)
    li.dataset.chatBotSkillName = item.name
    li.querySelector('.js-chat-bot-skill-menu-item-title').textContent =
      item.title
    const desc = li.querySelector('.js-chat-bot-skill-menu-item-description')
    if (item.description) {
      desc.textContent = item.description
    } else {
      desc.remove()
    }
    ul.appendChild(li)
  })

  return menu
}

function dispatchEventToMenu(menuTarget, event) {
  menuTarget.dispatchEvent(new CustomEvent(event))
}

export default {
  pluginKey,
  char: '/',
  // Exclude URL slashes during matching. ChatBotSkill's allow callback further
  // restricts suggestions to the very beginning of the message.
  allowedPrefixes: [' ', null],
  items: ({ query, editor }) => {
    const skills = getExtensionOption(editor, 'chatBotSkill', 'skills') || []
    const q = query.toLowerCase()
    return skills.filter(
      (s) =>
        s.name.toLowerCase().includes(q) ||
        s.title?.toLowerCase().includes(q) ||
        s.description?.toLowerCase().includes(q)
    )
  },
  render: () => {
    let popup
    let container

    const updateMenu = (obj) => {
      $(container).off('click', 'li a')
      popup[0].setContent(buildMenuContent(obj.items))
      $(container).on('click', 'li a', function (e) {
        const name = e.currentTarget.closest('li').dataset.chatBotSkillName
        if (name) obj.command({ name })
      })
    }

    return {
      onBeforeStart(obj) {
        const template = document.querySelector(
          '.js-chat-bot-skill-suggestions-container-template'
        )
        container = template.content.firstElementChild.cloneNode(true)
        resolveTippyPortal().append(container)
        popup = tippy('body', {
          getReferenceClientRect: obj.clientRect,
          appendTo: () => container,
          content: buildMenuContent([]),
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          offset: [10, 0],
          popperOptions: { strategy: 'fixed' },
        })
      },
      onStart: updateMenu,
      onUpdate: updateMenu,
      onKeyDown(props) {
        const key = props.event.key
        const menuTarget = popup[0].popper.querySelector(
          '.js-chat-bot-skill-menu'
        )
        // Don't intercept ArrowRight: this menu has no cols/sections for it to
        // navigate, so capturing it here only blocked the caret from moving
        // past the "/" token, trapping the user until they clicked away.
        if (key === 'Escape') {
          props.event.cancelBubble = true
          popup[0].hide()
        } else if (key === 'ArrowDown') {
          dispatchEventToMenu(menuTarget, 'menu:arrowDown')
        } else if (key === 'ArrowUp') {
          dispatchEventToMenu(menuTarget, 'menu:arrowUp')
        } else if (key === 'Enter' || key === 'Tab') {
          props.event.preventDefault()
          dispatchEventToMenu(menuTarget, 'menu:enterKey')
        } else {
          return false
        }

        return true
      },
      onExit() {
        popup[0].destroy()
        container.remove()
      },
    }
  },
}
